import React from "react";
import { withRouter } from "react-router-dom";
import withFirebase from "../hoc/withFirebase";
import { Route } from "react-router-dom";
import withUser from "../hoc/withUser";
import GenerateInvoice from "../components/GenerateInvoice";

class GenerateInvoiceContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      pendingInvoice: [],
      completeInvoice: [],
      allCustomers: [],
      allDeals: [],
      selectedCustomerName: null,
      customersList: [],
      appBarName: "",
      organisationId: ""
    };
  }
  componentWillMount() {
    this.initializeData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.initializeData(nextProps);
  }
  initializeData = whichProps => {
    let deals = whichProps.allDeals;
    let customerId = this.props.match.params.customerId;
    let allCustomers = whichProps.allCustomers.find(
      customer => customer.id === this.props.match.params.customerId
    );
    let allInvoices = whichProps.allInvoices;
    const invoicedDealsId = [];
    const invalidCustomers = [];
    let allCustomerDeals = whichProps.allCustomerDeals;
    let appBarName = allCustomers.name;
    let customersList = [];
    let tempCustomers = [];
    let tempAllCustomers = [];
    this.setState({ appBarName });
    if (whichProps.organisations !== undefined) {
      this.setState({
        organisationId: whichProps.organisations.organisationId
      });
    }
    allInvoices.length > 0
      ? allInvoices.map(dealsId =>
          dealsId.dealsId.map(data => invoicedDealsId.push(data))
        )
      : console.log("No Invoices Generated Yet");
    tempAllCustomers = allCustomerDeals.filter(
      aCustomerDeals =>
        aCustomerDeals.customerId === customerId &&
        aCustomerDeals.isInvoiceCreated === false
    );
    deals
      .filter(
        deals => deals.buyerId === customerId || deals.sellerId === customerId
      )
      .map(deals => {
        if (invoicedDealsId.length > 0) {
          if (
            invoicedDealsId.find(
              invoiceDeals => invoiceDeals.dealId !== deals.id
            )
          ) {
            let a = deals;
            if (customerId === deals.buyerId) {
              a.customerName = deals.sellerName;
              a.customerId = deals.sellerId;
              a.brokerage = deals.buyerBrokerage;
            }
            if (customerId === deals.sellerId) {
              a.customerName = deals.buyerName;
              a.customerId = deals.buyerId;
              a.brokerage = deals.sellerBrokerage;
            }
            tempCustomers.push(a);
          }
        } else {
          let a = deals;
          if (customerId === deals.buyerId) {
            a.customerName = deals.sellerName;
            a.customerId = deals.sellerId;
            a.brokerage = deals.buyerBrokerage;
          }
          if (customerId === deals.sellerId) {
            a.customerName = deals.buyerName;
            a.customerId = deals.buyerId;
            a.brokerage = deals.sellerBrokerage;
          }
          tempCustomers.push(a);
        }
        return tempCustomers;
      });
    customersList = [...new Set(tempCustomers)];
    this.setState({ customersList });
    let invoiceDeals = [];
    if (tempAllCustomers.length > 0) {
      tempAllCustomers.map(tACustomerDeals => {
        return invoiceDeals.push(tACustomerDeals.dealId);
      });
    } else {
      console.log("false");
    }
    if (invoiceDeals.length > 0) {
      customersList = customersList.filter(val =>
        invoiceDeals.includes(val.id)
      );

      this.setState({ customersList });
    } else {
      allInvoices.length > 0
        ? allInvoices
            .filter(allInvoice => allInvoice.customerId === customerId)
            .map(data =>
              data.otherPartyId.map(opId => invalidCustomers.push(opId))
            )
        : console.log("No Invoices Generated Yet");
      customersList = customersList.filter(
        val => !invalidCustomers.includes(val.customerId)
      );
      this.setState({ customersList });
    }
  };
  generateInvoice = invoice => {
    this.props.db
      .collection("invoices")
      .add(invoice)
      .then(
        invoice.dealsId.map(dealsId => {
          return this.props.db
            .collection("customerDeals")
            .doc(invoice.customerId + "_" + dealsId)
            .update({ isInvoiceCreated: true });
        })
      );
  };
  render() {
    const { customersList, appBarName, organisationId } = this.state;
    const { user, allInvoices } = this.props;
    return (
      <div>
        <Route
          exact
          path="/invoice/:customerId/generateInvoice"
          render={props => (
            <GenerateInvoice
              {...props}
              generateInvoice={this.generateInvoice}
              user={user}
              selectedCustomerName={appBarName}
              customersList={customersList}
              allInvoices={allInvoices}
              organisationId={organisationId}
            />
          )}
        />
      </div>
    );
  }
}

export default withRouter(withUser(withFirebase(GenerateInvoiceContainer)));
